





























import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

import GatewayList from './component/GatewayList.vue';
import PcList from './component/PcList.vue';
import ConnectionList from './component/ConnectionList.vue';
import ExtranetSetting from './component/ExtranetSetting.vue';
import LogList from "@/views/console/remote-connect-manage/component/LogList.vue";
import HistoricalTraffic from "@/views/console/remote-connect-manage/component/HistoricalTraffic.vue";

@Component({
  components: {
    HistoricalTraffic,
    LogList,
    GatewayList,
    PcList,
    ConnectionList,
    ExtranetSetting,
  },
})
export default class RemoteConnectManage extends Vue {
  noTitleKey= 'gateway-list';
  tabListNoTitle=[
    {
      key: 'gateway-list',
      tab: '网关列表',
    },
    {
      key: 'pc-list',
      tab: 'PC列表',
    },
    {
      key: 'connection-list',
      tab: '连接列表',
    },
    {
      key: 'ExtranetSetting',
      tab: '功能设置',
    },
    {
      key: 'LogList',
      tab: '日志',
    },
    {
      key: 'HistoricalTraffic',
      tab: '历史流量',
    }
  ];

  onTabChange(key) {
    this.noTitleKey = key;
  }
}
